// extracted by mini-css-extract-plugin
export default {"value-box":"value-box_value-box__UBZ7K","web":"value-box_web__wj3m4","value":"value-box_value__fH-Ac","mobile":"value-box_mobile__Jqu9k"};